import { render, staticRenderFns } from "./IncidentTrend.vue?vue&type=template&id=5f1f3168"
import script from "./IncidentTrend.vue?vue&type=script&lang=js"
export * from "./IncidentTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports